export const FIELD_GOODS_SKU = 'goodsSku'
export const FIELD_GOODS_SKUDETAIL = 'goodsSkuDetail'
